import { ContactsData } from '../interfaces';

export const CONTACT_FIELDS_TO_TRANSFORM: Array<keyof ContactsData> = [
  'state',
  'contactType',
  'projectType',
];
